<template>
  <div
    class="fc-user-avatar"
    :style="avatarStyle"
    :aria-hidden="ariaHidden"
    :aria-label="ariaLabel"
    :role="ariaLabel ? 'img' : undefined"
    :data-testid="dataTestId"
  >
    <span class="fc-user-avatar__initial">{{ displayInitial }}</span>
  </div>
</template>

<script>
import './FcUserAvatar.scss';

/**
 * FC user avatar — Figma initials circle (single letter, shared secondary fill).
 *
 * @example
 * <FcUserAvatar name="Jane Doe" />
 * <FcUserAvatar :name="owner.name" :email="owner.email" :size="32" />
 */
export default {
  name: 'FcUserAvatar',
  props: {
    /** Display name used to derive the initial. */
    name: {
      type: String,
      default: '',
    },
    /** Fallback when name is empty. */
    email: {
      type: String,
      default: '',
    },
    /** Explicit initial; overrides name/email derivation. */
    initial: {
      type: String,
      default: '',
    },
    /** Diameter in pixels. */
    size: {
      type: [Number, String],
      default: 32,
    },
    dataTestId: {
      type: String,
      default: 'fc-user-avatar',
    },
  },
  computed: {
    displayInitial() {
      const explicit = (this.initial || '').trim();
      if (explicit) return explicit.charAt(0).toUpperCase();

      const source = (this.name || this.email || '').trim();
      return source ? source.charAt(0).toUpperCase() : '?';
    },
    numericSize() {
      const parsed = Number(this.size);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 32;
    },
    avatarStyle() {
      const size = `${this.numericSize}px`;
      return {
        width: size,
        height: size,
        fontSize: `${Math.max(10, Math.round(this.numericSize * 0.4375))}px`,
      };
    },
    ariaLabel() {
      const label = (this.name || this.email || '').trim();
      return label || undefined;
    },
    ariaHidden() {
      return this.ariaLabel ? undefined : 'true';
    },
  },
};
</script>
